import { App } from './interfaces'

export default function isAppOwner(app: App | undefined, userId: string) {
  if (!app || !userId) return false

  return !!app.sharedWith?.includes(userId)
}
